<div class="main-card">
    <app-weather-card [@showUpElement] [weather]="weatherService.weather$ | async"></app-weather-card>
</div>